import { routerMiddleware } from "connected-react-router";
import { createHashHistory } from "history";
import { applyMiddleware, createStore , Middleware, Store } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import createSagaMiddleware from "redux-saga";
import nodeEnvironments from "../constants/nodeEnvironments";
import toCamelCaseMiddleware from "./fixApiCasing";
import createRootReducer, { RootState } from "./rootReducer";
import registerWithMiddleware from "./sagaRegistration";

const sagaMiddleware = createSagaMiddleware();
export const history = createHashHistory();

const middlewares = [
  routerMiddleware(history),
  toCamelCaseMiddleware,
  sagaMiddleware,
] as Middleware[];

export const configureStore = (): Store<RootState> => {
  const appliedMiddlewares = applyMiddleware(...middlewares);
  const composed = (window as any).devToolsExtension && process.env.NODE_ENV !== nodeEnvironments.prod
    ? composeWithDevTools(appliedMiddlewares)
    : appliedMiddlewares;

  const store = createStore(
      createRootReducer(history),
    composed,
  ) as Store<RootState>;

  registerWithMiddleware(sagaMiddleware);

  return store;
};

export const store = configureStore();
